function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.168 5.001c39.894.078 79.789.078 119.683.156 19.649 0 39.447.078 59.097.078 16.672 0 37.363-1.246 51.505 4.516l3.573-3.27C160.47.33 81.872-1.461 3.573 1.186c-4.764.156-4.764 3.66 0 3.893 31.558 1.48 63.265 2.336 95.12 2.647 29.921.312 60.735.545 88.423 7.086 4.317 1.012 8.187-2.336 3.721-3.348-27.39-6.463-57.31-7.241-86.933-7.553C70.41 3.522 36.917 2.744 3.573 1.186V5.08C81.128 2.51 159.13 4.145 236.09 10.14c3.126.234 6.997-1.869 3.573-3.27-12.653-5.139-27.985-5.606-43.467-5.606-21.138-.078-42.425-.078-63.563-.078-42.722 0-85.594-.078-128.465-.078-4.763 0-4.763 3.893 0 3.893z",
  fill: "#FFD747"
});

function SvgYellowDash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgYellowDash;